import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postCategory } from '../Api'

export default generateApiAction({
  baseType: Types.CATEGORIES.POST,
  api: postCategory,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/categories/PostAction.js